import { styled } from 'styled-components'

export const StyledPillContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const StyledPill = styled.div`
  flex: 1;
  width: fit-content;
  padding: 0.6em;
  margin: 0.5em;
  font-size: 1.2em;
  color: ${({ theme }) => theme.colors.palette.ghostWhite};
  background-color: ${({ theme }) => theme.colors.palette.darkBlack};
  border-radius: .8em;
  box-shadow: 0 0 4px 2px ${({ theme }) => theme.colors.palette.darkBlack};
`
